import styled from '@emotion/styled'

export const ContactDetailsWrapper = styled.div({
  marginBottom: 24,
})

export const Row = styled.div({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between'
})

export const LeftColumn = styled.div(({theme}) => ({
  width: 'calc(40% - 5px)',
  fontWeight: theme.fontWeights.bold,
  fontSize: theme.fonts.pxToRem(16),
  lineHeight: 2,
  [theme.breakpoint.down('md')]: {
    fontSize: theme.fonts.pxToRem(14),
    lineHeight: 1.714
  }
}))

export const RightColumn = styled(LeftColumn)(({theme}) => ({
  width: 'calc(60% - 5px)',
  fontWeight: theme.fontWeights.body,

  '& > a': {
    color: theme.colors.B300,
  }
}))
